import React, { useState, useEffect, useRef } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Modal, Steps, Input, Button, Select, Spin, Radio, AutoComplete, Form } from 'antd'
import { useDispatch } from 'react-redux'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { getAllCountries } from '../../../helpers'
import customLanguageTexts from '../../../language'
import constants from '../../../constants'

const { Step } = Steps

const ModalOnboarding = ({ visibleModalID, user }) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [state, setState] = useState({
    currentStep: 0,
    timerLength: 19,
    currentSecond: 0,
    appCreation: false,
    accountType: 'Personal',
    userContactNumber: '',
    userCountryCode: 'us',
    userCountry: '',
  })

  const timerInterval = useRef(null)
  const timer = useRef(null)

  useEffect(() => {
    let userCountryCode = 'us'
    if (
      user?.meta?.countryCode !== undefined &&
      user?.meta?.countryCode !== '' &&
      user?.meta?.countryCode
    ) {
      userCountryCode = user?.meta?.countryCode
    }
    setState(prev => ({
      ...prev,
      userCountryCode,
      userContactNumber: user?.contactNumber,
      userCountry: user?.meta?.country,
    }))

    return () => {
      if (timerInterval.current) clearInterval(timerInterval.current)
      if (timer.current) clearTimeout(timer.current)
    }
  }, [user])

  const selectStep = async step => {
    try {
      const values = await form.validateFields()
      if (step === 2) {
        dispatch({
          type: 'user/ONBOARDING_STEP2',
          payload: values,
          onComplete: changeStep,
        })
      } else if (step === 1) {
        const { userContactNumber, userCountryCode } = state
        values.contactNumber = userContactNumber
        values.countryCode = userCountryCode
        dispatch({
          type: 'user/UPDATE_USER_PROFILE',
          payload: values,
          onComplete: changeStep,
        })
      }
    } catch (error) {
      console.error('Validation failed:', error)
    }
  }

  const changeStep = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      let step = 1
      if (state.currentStep === 1) step = 2

      setState(prev => ({
        ...prev,
        currentStep: step,
      }))
    }
  }

  const onSubmit = async event => {
    event.preventDefault()
    const { timerLength } = state
    clearInterval(timerInterval.current)

    try {
      const values = await form.validateFields()
      values.onBoarding = true
      dispatch({
        type: 'apps/ADD',
        payload: values,
      })
      if (constants.captureGTMEvents && window.CometChatAnalytics) {
        window.CometChatAnalytics.event(constants.GAEvents.app_creation)
      }

      setState(prev => ({
        ...prev,
        appCreation: true,
      }))

      timerInterval.current = setInterval(() => {
        setState(prev => ({
          ...prev,
          currentSecond: prev.currentSecond + 1,
        }))
      }, 1000)

      timer.current = setTimeout(() => {
        handleCancel()
      }, timerLength * 1000)
    } catch (error) {
      console.error('Form validation failed:', error)
    }
  }

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })

    clearInterval(timerInterval.current)
    clearTimeout(timer.current)
    setTimeout(() => {
      setState(prev => ({
        ...prev,
        currentStep: 0,
        currentSecond: 0,
        appCreation: false,
      }))
    }, 500)
  }

  const handleChange = (type, value) => {
    setState(prev => ({
      ...prev,
      [type]: value,
    }))
  }

  const handlePhoneNumberChange = (phone, data) => {
    setState(prev => ({
      ...prev,
      userContactNumber: phone,
      userCountryCode: data.countryCode,
      userCountry: data.name,
    }))
  }

  const modalID = 'onboarding'
  const visible = modalID === visibleModalID
  const {
    currentStep,
    appCreation,
    currentSecond,
    timerLength,
    accountType,
    userContactNumber,
    userCountry,
    userCountryCode,
  } = state

  let companyNameComponent = ''
  let agencyNameComponent = ''
  let employeeStrengthComponent = ''

  if (accountType === 'Company') {
    companyNameComponent = (
      <div className="col-lg-6">
        <Form.Item label="Company Name" name="company" initialValue={user?.meta?.company || ''}>
          <Input />
        </Form.Item>
      </div>
    )
    employeeStrengthComponent = (
      <div className="col-lg-6">
        <Form.Item
          label="Employee strength"
          name="employees"
          initialValue={user?.meta?.employees || ''}
        >
          <Select>
            <Select.Option value="">Select employee strength</Select.Option>
            <Select.Option value="1-10">1-10</Select.Option>
            <Select.Option value="10-50">10-50</Select.Option>
            <Select.Option value="50-200">50-200</Select.Option>
            <Select.Option value="200-2500">200-2500</Select.Option>
            <Select.Option value=">2500">&gt;2500</Select.Option>
          </Select>
        </Form.Item>
      </div>
    )
  } else if (accountType === 'Agency') {
    agencyNameComponent = (
      <div className="col-lg-6">
        <Form.Item label="Agency Name" name="agency" initialValue={user?.meta?.agency || ''}>
          <Input />
        </Form.Item>
      </div>
    )
    employeeStrengthComponent = (
      <div className="col-lg-6">
        <Form.Item
          label="Employee strength"
          name="employees"
          initialValue={user?.meta?.employees || ''}
        >
          <Select>
            <Select.Option value="">Select employee strength</Select.Option>
            <Select.Option value="1-10">1-10</Select.Option>
            <Select.Option value="10-50">10-50</Select.Option>
            <Select.Option value="50-200">50-200</Select.Option>
            <Select.Option value="200-2500">200-2500</Select.Option>
            <Select.Option value=">2500">&gt;2500</Select.Option>
          </Select>
        </Form.Item>
      </div>
    )
  }

  return (
    <Modal
      className="com__modal"
      title={<span className="font-size-24">Onboarding</span>}
      open={visible}
      closable={false}
      maskClosable={false}
      destroyOnHidden
      footer={null}
    >
      <Steps current={currentStep}>
        <Step title="Welcome" />
        <Step title="A little more" />
        <Step title="Create App" />
      </Steps>
      <Form
        form={form}
        layout="vertical"
        hideRequiredMark
        onSubmit={onSubmit}
        className="mt-5 mb-4"
      >
        {currentStep === 0 && (
          <div>
            <div className="com__fields">
              <Form.Item
                label="Name"
                name="name"
                initialValue={user?.name}
                rules={[{ required: true, message: 'Please input your Name' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                initialValue={user?.email}
                rules={[{ required: true, message: 'Please input your e-mail address' }]}
              >
                <Input autoComplete="username" disabled />
              </Form.Item>
              <Form.Item label="Phone">
                <PhoneInput
                  dropdownClass="contactNumberCode"
                  inputClass="contactNumberInput"
                  buttonClass="contactNumberButton"
                  enableSearch="true"
                  placeholder="XXX-XXX-XXXX"
                  country={userCountryCode}
                  value={userContactNumber}
                  onChange={(phone, data) => handlePhoneNumberChange(phone, data)}
                />
              </Form.Item>
              <Form.Item label="Country" name="country" initialValue={userCountry || ''}>
                <AutoComplete
                  dataSource={getAllCountries()}
                  filterOption={(inputValue, option) =>
                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                />
              </Form.Item>
            </div>
            <div className="com__formLine" />
            <Button
              loading={user?.loading}
              type="primary"
              className="com__button mr-5"
              onClick={() => selectStep(1)}
            >
              Continue
            </Button>
            <a role="button" tabIndex="-1" onKeyPress={handleCancel} onClick={handleCancel}>
              Cancel
            </a>
          </div>
        )}
        {currentStep === 1 && (
          <div>
            <div className="com__fields">
              <Form.Item
                label="Account Type"
                name="account"
                initialValue={accountType || 'Personal'}
                rules={[{ required: true, message: 'Please select Account Type' }]}
              >
                <Radio.Group
                  buttonStyle="solid"
                  onChange={e => handleChange('accountType', e.target.value)}
                >
                  <Radio.Button value="Company">Company</Radio.Button>
                  <Radio.Button value="Personal">Personal</Radio.Button>
                  <Radio.Button value="Agency">Agency</Radio.Button>
                </Radio.Group>
              </Form.Item>
              <div className="row">
                {companyNameComponent}
                {agencyNameComponent}
                {employeeStrengthComponent}
              </div>
              <Form.Item
                label="You are a ?"
                name="role"
                initialValue={user?.meta?.role || 'Developer'}
              >
                <Radio.Group
                  buttonStyle="solid"
                  className="com__clusterIcons"
                  onChange={e => handleChange('accountRole', e.target.value)}
                >
                  <Radio.Button value="Developer">Developer</Radio.Button>
                  <Radio.Button value="Non developer">Non developer</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className="com__formLine" />
            <Button
              loading={user?.loading}
              type="primary"
              className="com__button mr-5"
              onClick={() => selectStep(2)}
            >
              Continue
            </Button>
            <a role="button" tabIndex="-1" onKeyPress={handleCancel} onClick={handleCancel}>
              Cancel
            </a>
          </div>
        )}
        {currentStep === 2 && (
          <div>
            <div className="com__fields">
              <Form.Item
                label="Name"
                name="name"
                initialValue="My first app"
                rules={[{ required: true, message: 'Please input app Name' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Region"
                name="region"
                initialValue="us"
                rules={[{ required: true, message: 'Please select Region' }]}
              >
                <Radio.Group buttonStyle="solid" className="com__clusterIcons">
                  <Radio.Button value="us">
                    <img src="/resources/images/flags/us.png" alt="US" />
                    US
                  </Radio.Button>
                  <Radio.Button value="eu">
                    <img src="/resources/images/flags/eu.png" alt="EU" />
                    EU
                  </Radio.Button>
                  <Radio.Button value="hipaa-us" className="hipaa-app-region">
                    <img
                      src="/resources/images/flags/hippa.png"
                      alt="US (HIPAA COMPLIANT)"
                      className="hippa-appcard-icon"
                    />
                    US (HIPAA COMPLIANT)
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <span>{customLanguageTexts.ADD_NEW_APP_CARD_REGION_TEXT}</span>
            </div>
            <div className="com__formLine" />
            <Button
              loading={user?.loading}
              type="primary"
              className="com__button mr-4"
              onClick={onSubmit}
              htmlType="submit"
            >
              Add App
            </Button>
            <a role="button" tabIndex="-1" onKeyUp={handleCancel} onClick={handleCancel}>
              Add Later
            </a>
          </div>
        )}
      </Form>
      {appCreation && (
        <div className="com__appLoading">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
          <p>
            <span className="font-size-21">We are configuring your app.</span>
            <br />
            <span className="font-size-18">
              Please allow us <strong>{timerLength - currentSecond}</strong> seconds.
            </span>
          </p>
        </div>
      )}
    </Modal>
  )
}

export default ModalOnboarding
